export default __webpack_public_path__ + "static/media/enterprise.13a663b6.png";